import SidebarHeader from './SidebarHeader.container'

export default SidebarHeader
